export default {
  failed_to_open: "Impossibile aprire l'onboarding per questo ristorante. Riprova.",
};
